import AnimationScreen from 'components/AnimationScreens/AnimationScreen';
import ANIMATION_SCREENS from 'components/AnimationScreens/registry';
import useAnimationScreen from 'hooks/common/useAnimationScreen';

function AnimationScreenRouter() {
  const { animations } = useAnimationScreen();

  return (
    <>
      {Object.keys(animations).map((id) => {
        const animation = animations[id];
        const Content = ANIMATION_SCREENS[id];
        if (animation.status === 'idle' || !Content) {
          return null;
        }

        const mergedOptions = { ...animation.options, ...Content.options };
        const Component = Content.content;

        return (
          <AnimationScreen key={id} id={id} animation={{ ...animation, options: mergedOptions }} status={animation.status}>
            <Component />
          </AnimationScreen>
        );
      })}
    </>
  );
}

export default AnimationScreenRouter;
